import React from 'react'

export default function ActionCheckIcon() {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.5" y="0.5" width="31" height="31" rx="15.5" fill="white" />
            <rect x="0.5" y="0.5" width="31" height="31" rx="15.5" stroke="#ECEBF7" />
            <path d="M11 16L14.5 19.5L21 13" stroke="#B1AEC7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}
